"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_WEBCAM_INITIALIZATION = exports.ERROR_MODULE_NOT_INITIALIZED = exports.ERROR_MODULE_INITIALIZATION = void 0;
exports.ERROR_MODULE_INITIALIZATION = 'Error module initialization';
exports.ERROR_MODULE_NOT_INITIALIZED = 'Error module isn\'t initialized';
exports.ERROR_WEBCAM_INITIALIZATION = 'Error webcam initialization';
//# sourceMappingURL=errors.js.map